if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = this.closest('.section-main-product');
        this.mainProductForm = this.section.querySelector('.js-product');
        this.buyButtons = this.section.querySelector('buy-buttons');
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantContainer = this.querySelector('.sticky-atc__details__variant');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));

        this.throttledOnScroll = throttle(this.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
        this.initialVisibilityCheck();

        // Bind form submit event to handle the correct variant
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      /**
       * Handles submission of the product form.
       * @param {object} evt - Event object.
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('product-form input[name="id"]').value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }

        // Validate main form
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductForm.form.reportValidity()) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductForm.form.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Copy data
        this.copyFormData();

        // Proceed with submission
        super.handleSubmit(evt);
      }

      /**
       * Copy form data from the main product form to the sticky form.
       */
      copyFormData() {
        this.form.querySelectorAll('[data-copied]').forEach((el) => el.remove());
        const formData = new FormData(this.mainProductForm.form);
        for (const [name, value] of formData) {
          if (!this.form.querySelector(`[name="${name}"]`)) {
            const input = document.createElement('input');
            input.name = name;
            input.value = value;
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.form.append(input);
          } else {
            this.form.querySelector(`[name="${name}"]`).value = value;
          }
        }
      }

      /**
       * Initial check to set the visibility of the sticky ATC on page load.
       * Sticky should only show AFTER scrolling past the main buy buttons.
       */
      initialVisibilityCheck() {
        const topOffset = document.querySelector('.pageheader--sticky')
          ? document.querySelector('.section-header').offsetHeight
          : 0;

        if (!this.buyButtons) return;

        const rect = this.buyButtons.getBoundingClientRect();

        // Show sticky only when the buy buttons are above the viewport (scrolled past)
        const hasScrolledPastBuyButtons = rect.bottom <= topOffset;

        // sticky-atc--out = hidden
        this.classList.toggle('sticky-atc--out', !hasScrolledPastBuyButtons);
      }

      /**
       * Determine visibility after scroll.
       * Sticky should only show AFTER scrolling past the main buy buttons.
       */
      handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky')
          ? document.querySelector('.section-header').offsetHeight
          : 0;

        if (!this.buyButtons) return;

        const rect = this.buyButtons.getBoundingClientRect();

        // Show sticky only when the buy buttons are above the viewport (scrolled past)
        const hasScrolledPastBuyButtons = rect.bottom <= topOffset;

        // sticky-atc--out = hidden
        this.classList.toggle('sticky-atc--out', !hasScrolledPastBuyButtons);

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      /**
       * Handle a change in variant on the page.
       * @param {Event} evt - Variant change event dispatched by variant-picker.
       */
      onVariantChange(evt) {
        const idInput = this.form?.querySelector('[name="id"]');

        if (evt.detail.variant) {
          this.variantTitle.textContent = evt.detail.variant.title;
          this.variantContainer.hidden = false;
          if (idInput) idInput.value = evt.detail.variant.id;
        } else {
          this.variantContainer.hidden = true;
          this.variantTitle.textContent = '';
          if (idInput) idInput.value = '';
        }

        this.updateImage();
        this.updateAddToCartButton(evt.detail.variant);
        this.setErrorMsgState();
      }

      /**
       * Updates the image.
       */
      updateImage() {
        const mainImage = this.section.querySelector(
          '.media-gallery .main-image .slider__item.is-active .product-media img'
        );

        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      /**
       * Updates the "Add to Cart" button label and status.
       * @param {object} variant - Current variant object.
       */
      updateAddToCartButton(variant) {
        if (!this.submitBtn) return;

        const variantAvailable = variant && variant.available;
        const unavailableStr = variant
          ? theme.strings.noStock
          : this.submitBtn.dataset.unavailableText;

        this.submitBtn.textContent = variantAvailable
          ? this.submitBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}